import { PalletRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class PalletService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PalletRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	exitScan(resource, sourceOfChange) {
		var url = this.routeService.exitScan(resource, sourceOfChange);
		return this.apiClient.put(url);
	}
}

export default PalletService;



// WEBPACK FOOTER //
// ./src/common/data/services/PalletService.js